// extracted by mini-css-extract-plugin
export default {"root":"CustomEmojiSetsModal-module__root","sets":"CustomEmojiSetsModal-module__sets"};